import React from 'react';
import { termsOfUseUrl, privacyPolicyUrl } from '../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import UrlLink from '@material-ui/core/Link';

const useStyles = makeStyles((theme: any) => ({
  container: { marginTop: theme.spacing(2), textAlign: 'center' },
  termsOfUse: { marginRight: theme.spacing(2) },
  PrivacyPolicy: { marginLeft: theme.spacing(2) },
}));

export default function TermOfUseAndPrivacyPolicy() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div>
        <UrlLink
          className={classes.termsOfUse}
          href={termsOfUseUrl}
          target="_blank"
        >
          Terms of Use
        </UrlLink>{' '}
        .
        <UrlLink
          className={classes.PrivacyPolicy}
          href={privacyPolicyUrl}
          target="_blank"
        >
          Privacy Policy
        </UrlLink>
      </div>
    </div>
  );
}
